import { identifier, serializable } from 'serializr';
import { AlgoBodySelection, CommonAlgoResponse } from '../CommonAlgoResponse';

export class PermanentAlgoResponse implements CommonAlgoResponse {
  @serializable(identifier())
  private id?: number;

  @serializable
  private question?: number;

  @serializable
  label?: string;

  @serializable
  orderValue?: number;

  @serializable
  excludeOthers?: boolean;

  @serializable
  verticalTargetRoutes?: boolean;

  @serializable
  bodyKey?: AlgoBodySelection;

  get Id() {
    if (this.id === undefined) {
      throw new Error('Undefined field "id"');
    }
    return this.id;
  }

  get questionId() {
    if (this.question === undefined) {
      throw new Error('Undefined field "question"');
    }
    return this.question;
  }
}
